(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pd-fit-in-motion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pd-fit-motion')) {
    customElements.define('pd-fit-motion', class extends HTMLElement {
      connectedCallback() {
        if (this.video) return;
        this.video = this.querySelector('video');
        this.button = this.querySelector('.pd-motion__toggle');
        this.products = [...this.querySelectorAll('[data-start]')];
        this.mobile = matchMedia('(max-width:700px)');
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.setAttribute('muted', '');
        this.video.setAttribute('playsinline', '');
        this.video.setAttribute('webkit-playsinline', '');
        this.retryTimers = [];
        this.button.hidden = false;
        this.userPaused = false;
        this.onToggle = () => {
          if (this.video.paused) {this.userPaused = false;this.video.play().catch(() => {});}
          else {this.userPaused = true;this.video.pause();}
        };
        this.onVideoClick = () => this.onToggle();
        this.onVideoKey = event => {
          if (event.key === ' ' || event.key === 'Enter') {event.preventDefault();this.onToggle();}
        };
        this.onState = () => {
          const playing = !this.video.paused;
          this.button.toggleAttribute('data-playing', playing);
          this.button.setAttribute('aria-label', playing ? this.button.dataset.pause : this.button.dataset.play);
          this.video.setAttribute('aria-label', playing ? this.button.dataset.pause : this.button.dataset.play);
        };
        this.onProduct = () => {
          const duration = Number.isFinite(this.video.duration) ? this.video.duration : 18;
          const time = this.video.currentTime % duration;
          this.products.forEach(product => {product.hidden = !(time >= Number(product.dataset.start) && time < Number(product.dataset.end));});
        };
        this.onMobile = () => {
          this.video.tabIndex = 0;this.video.setAttribute('role', 'button');
          this.onState();
          if (this.imagesNear) this.preloadProducts();
        };
        this.tryAutoplay = () => {
          if (this.video.autoplay && this.inView && !this.userPaused && !document.hidden) this.video.play().catch(() => {});
        };
        this.queueAutoplay = () => {
          this.retryTimers.forEach(clearTimeout);
          this.tryAutoplay();
          this.retryTimers = [250, 1000, 2500].map(delay => setTimeout(() => this.tryAutoplay(), delay));
        };
        this.onVisibility = () => {if (document.hidden) this.video.pause();else this.queueAutoplay();};
        this.onReturn = () => this.queueAutoplay();
        this.onGesture = event => {
          if (event.target === this.video || this.button.contains(event.target)) return;
          if (!this.video.autoplay || this.userPaused || document.hidden) return;
          this.video.muted = true;
          this.video.play().then(() => {if (!this.inView) this.video.pause();}).catch(() => {});
        };
        this.button.addEventListener('click', this.onToggle);
        this.video.addEventListener('click', this.onVideoClick);
        this.video.addEventListener('keydown', this.onVideoKey);
        this.video.addEventListener('play', this.onState);
        this.video.addEventListener('pause', this.onState);
        this.video.addEventListener('timeupdate', this.onProduct);
        this.video.addEventListener('canplay', this.queueAutoplay);
        this.video.addEventListener('loadeddata', this.queueAutoplay);
        window.addEventListener('pageshow', this.onReturn);
        window.addEventListener('focus', this.onReturn);
        document.addEventListener('touchend', this.onGesture, {passive:true});
        document.addEventListener('click', this.onGesture);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.mobile.addEventListener('change', this.onMobile);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          if (this.inView) this.tryAutoplay();
          else this.video.pause();
        }, {threshold:0.01,rootMargin:'0px'});
        this.observer.observe(this.video);
        this.imageObserver = new IntersectionObserver(entries => {
          this.imagesNear = entries[0].isIntersecting;
          if (this.imagesNear) this.preloadProducts();
        }, {rootMargin:'600px 0px',threshold:0});
        this.imageObserver.observe(this);
        this.onMobile();
        this.onProduct();
      }
      preloadProducts() {
        if (this.imagesRequested) return;
        this.imagesRequested = true;
        this.querySelectorAll('.pd-motion__outfits img').forEach(image => {
          image.loading = 'eager';
          image.decoding = 'async';
          image.decode?.().catch(() => {});
        });
        this.imageObserver?.disconnect();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.imageObserver?.disconnect();
        this.video?.pause();
        this.button?.removeEventListener('click', this.onToggle);
        this.video?.removeEventListener('click', this.onVideoClick);
        this.video?.removeEventListener('keydown', this.onVideoKey);
        this.video?.removeEventListener('play', this.onState);
        this.video?.removeEventListener('pause', this.onState);
        this.video?.removeEventListener('timeupdate', this.onProduct);
        this.video?.removeEventListener('canplay', this.queueAutoplay);
        this.video?.removeEventListener('loadeddata', this.queueAutoplay);
        this.retryTimers?.forEach(clearTimeout);
        window.removeEventListener('pageshow', this.onReturn);
        window.removeEventListener('focus', this.onReturn);
        document.removeEventListener('touchend', this.onGesture);
        document.removeEventListener('click', this.onGesture);
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.mobile?.removeEventListener('change', this.onMobile);
        this.video = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-fit-review-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pd-fit-review-nav')) customElements.define('pd-fit-review-nav',class extends HTMLElement {
    connectedCallback(){
      this.buttons=[...this.querySelectorAll('button')];
      this.panels=[...this.closest('main').querySelectorAll('pd-fit-motion')].map(el=>el.closest('.shopify-section'));
      this.panels.forEach((panel,i)=>{panel.classList.add('pd-fit-review-panel');panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby','pd-fit-tab-'+(i+1));this.buttons[i].id='pd-fit-tab-'+(i+1);this.buttons[i].setAttribute('aria-controls',panel.id);});
      this.select=index=>{this.buttons.forEach((button,i)=>{button.setAttribute('aria-selected',i===index?'true':'false');button.tabIndex=i===index?0:-1;this.panels[i].hidden=i!==index;});history.replaceState(null,'','#option'+(index+1));};
      this.onClick=event=>{const button=event.target.closest('[data-option]');if(button)this.select(Number(button.dataset.option)-1);};
      this.onKey=event=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();let i=this.buttons.indexOf(document.activeElement);if(event.key==='Home')i=0;else if(event.key==='End')i=2;else i=(i+(event.key==='ArrowRight'?1:2))%3;this.select(i);this.buttons[i].focus();};
      this.addEventListener('click',this.onClick);this.addEventListener('keydown',this.onKey);
      const index=Number(location.hash.replace('#option',''))-1;this.select(index>=0&&index<3?index:0);
    }
    disconnectedCallback(){this.removeEventListener('click',this.onClick);this.removeEventListener('keydown',this.onKey);}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-home-lineup"] && !Shopify.designMode) return;
  try {
    
function bindPdLineups(root){root.querySelectorAll('[data-pd-lineup]').forEach(function(section){if(section.dataset.filtersBound)return;section.dataset.filtersBound='true';section.querySelectorAll('[data-pd-filter]').forEach(function(button){button.addEventListener('click',function(){var category=button.dataset.pdFilter;section.querySelectorAll('[data-pd-filter]').forEach(function(other){other.setAttribute('aria-pressed',String(other===button))});section.querySelectorAll('[data-pd-category]').forEach(function(card){card.hidden=category!=='all'&&card.dataset.pdCategory!==category})})})})}
bindPdLineups(document);document.addEventListener('shopify:section:load',function(event){bindPdLineups(event.target.parentElement)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-main-gallery-review"]) return;
  try {
    
          (function(){
            function scInit(){
            var open=document.querySelector('[data-size-chart-open]');
            var modal=document.querySelector('[data-size-chart]');
            if(!open||!modal||modal.dataset.scBound)return;
            modal.dataset.scBound='1';
            document.body.appendChild(modal);
            function show(){document.documentElement.style.overflow='hidden';document.body.style.overflow='hidden';modal.hidden=false;requestAnimationFrame(function(){requestAnimationFrame(function(){modal.classList.add('is-open');});});}
            function hide(){document.documentElement.style.overflow='';document.body.style.overflow='';modal.classList.remove('is-open');setTimeout(function(){modal.hidden=true;},380);}
            open.addEventListener('click',function(e){e.preventDefault();show();});
            modal.addEventListener('click',function(e){if(e.target===modal||e.target.closest('[data-size-chart-close]'))hide();});
            document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!modal.hidden)hide();});
            var tables=modal.querySelectorAll('[data-sc-table]');
            if(!tables.length)return;
            var btns=modal.querySelectorAll('[data-sc-unit]');
            btns.forEach(function(b){b.addEventListener('click',function(){
              btns.forEach(function(x){x.classList.toggle('active',x===b);});
              var toCm=b.getAttribute('data-sc-unit')==='cm';
              modal.querySelectorAll('td[data-in]').forEach(function(td){
                var inch=parseFloat(td.getAttribute('data-in'));
                if(isNaN(inch)){return;}
                td.textContent=toCm?String(Math.round(inch*2.54*10)/10):String(Math.floor(inch*10+0.0001)/10);
              });
            });});
            tables.forEach(function(table){
              if(table.dataset.scBound)return;
              table.dataset.scBound='1';
              function clear(){table.querySelectorAll('.sc-hl,.sc-hl-cell').forEach(function(c){c.classList.remove('sc-hl','sc-hl-cell');});}
              table.addEventListener('mouseover',function(e){
                var cell=e.target.closest('td,th');if(!cell||!table.contains(cell))return;
                clear();
                var idx=cell.cellIndex,ri=cell.parentNode.rowIndex,rows=table.rows;
                for(var c=0;c<rows[ri].cells.length;c++)rows[ri].cells[c].classList.add('sc-hl');
                for(var r=0;r<rows.length;r++){if(rows[r].cells[idx])rows[r].cells[idx].classList.add('sc-hl');}
                cell.classList.remove('sc-hl');cell.classList.add('sc-hl-cell');
              });
              table.addEventListener('mouseleave',clear);
            });
            }
            scInit();
            if(!window.__scHook){
              window.__scHook=1;
              document.addEventListener('shopify:section:load',function(){
                document.querySelectorAll('body > [data-size-chart]').forEach(function(m){m.parentNode.removeChild(m);});
                scInit();
              });
            }
          })();
        
  if(!customElements.get('pd-mobile-product-gallery'))customElements.define('pd-mobile-product-gallery',class extends HTMLElement{
    connectedCallback(){
      if(this.track)return;
      this.track=this.querySelector('.pd-mobile-gallery__track');this.slides=[...this.querySelectorAll('[data-slide]')];this.buttons=[...this.querySelectorAll('[data-target]')];this.video=this.querySelector('video');this.reduced=matchMedia('(prefers-reduced-motion:reduce)');this.mobile=matchMedia('(max-width:700px)');this.userPaused=false;
      this.update=()=>{const index=Math.round(this.track.scrollLeft/this.track.clientWidth);this.buttons.forEach(button=>button.setAttribute('aria-pressed',Number(button.dataset.target)===index?'true':'false'));};
      this.select=event=>{const button=event.target.closest('[data-target]');if(!button)return;this.track.scrollTo({left:Number(button.dataset.target)*this.track.clientWidth,behavior:this.reduced.matches?'instant':'smooth'});};
      this.key=event=>{if(event.target!==this.track||!['ArrowLeft','ArrowRight'].includes(event.key))return;event.preventDefault();this.track.scrollBy({left:(event.key==='ArrowRight'?1:-1)*this.track.clientWidth,behavior:this.reduced.matches?'instant':'smooth'});};
      this.play=()=>{if(this.video&&this.visible&&this.mobile.matches&&!this.reduced.matches&&!this.userPaused&&!document.hidden)this.video.play().catch(()=>{});else this.video?.pause();};
      this.toggle=()=>{this.userPaused=!this.video.paused;if(this.userPaused)this.video.pause();else this.video.play().catch(()=>{});};
      this.videoKey=event=>{if(event.key===' '||event.key==='Enter'){event.preventDefault();this.toggle();}};
      this.state=()=>this.video.setAttribute('aria-label',this.video.paused?this.dataset.play:this.dataset.pause);
      this.addEventListener('click',this.select);this.track.addEventListener('scroll',this.update,{passive:true});this.track.addEventListener('keydown',this.key);
      if(this.video){this.video.muted=true;this.video.defaultMuted=true;this.video.setAttribute('playsinline','');this.video.setAttribute('webkit-playsinline','');this.video.setAttribute('role','button');this.video.tabIndex=0;this.video.autoplay=!this.reduced.matches;this.video.addEventListener('click',this.toggle);this.video.addEventListener('keydown',this.videoKey);this.video.addEventListener('play',this.state);this.video.addEventListener('pause',this.state);this.video.addEventListener('canplay',this.play);this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.play();},{threshold:.4});this.observer.observe(this.video);this.state();}
      document.addEventListener('visibilitychange',this.play);this.mobile.addEventListener('change',this.play);this.reduced.addEventListener('change',this.play);this.update();
    }
    disconnectedCallback(){this.observer?.disconnect();this.video?.pause();this.removeEventListener('click',this.select);this.track?.removeEventListener('scroll',this.update);this.track?.removeEventListener('keydown',this.key);this.video?.removeEventListener('click',this.toggle);this.video?.removeEventListener('keydown',this.videoKey);this.video?.removeEventListener('play',this.state);this.video?.removeEventListener('pause',this.state);this.video?.removeEventListener('canplay',this.play);document.removeEventListener('visibilitychange',this.play);this.mobile?.removeEventListener('change',this.play);this.reduced?.removeEventListener('change',this.play);this.track=null;}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-main-roomy-review"]) return;
  try {
    

          (function(){
            function scInit(){
            var open=document.querySelector('[data-size-chart-open]');
            var modal=document.querySelector('[data-size-chart]');
            if(!open||!modal||modal.dataset.scBound)return;
            modal.dataset.scBound='1';
            document.body.appendChild(modal);
            function show(){document.documentElement.style.overflow='hidden';document.body.style.overflow='hidden';modal.hidden=false;requestAnimationFrame(function(){requestAnimationFrame(function(){modal.classList.add('is-open');});});}
            function hide(){document.documentElement.style.overflow='';document.body.style.overflow='';modal.classList.remove('is-open');setTimeout(function(){modal.hidden=true;},380);}
            open.addEventListener('click',function(e){e.preventDefault();show();});
            modal.addEventListener('click',function(e){if(e.target===modal||e.target.closest('[data-size-chart-close]'))hide();});
            document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!modal.hidden)hide();});
            var tables=modal.querySelectorAll('[data-sc-table]');
            if(!tables.length)return;
            var btns=modal.querySelectorAll('[data-sc-unit]');
            btns.forEach(function(b){b.addEventListener('click',function(){
              btns.forEach(function(x){x.classList.toggle('active',x===b);});
              var toCm=b.getAttribute('data-sc-unit')==='cm';
              modal.querySelectorAll('td[data-in]').forEach(function(td){
                var inch=parseFloat(td.getAttribute('data-in'));
                if(isNaN(inch)){return;}
                td.textContent=toCm?String(Math.round(inch*2.54*10)/10):String(Math.floor(inch*10+0.0001)/10);
              });
            });});
            tables.forEach(function(table){
              if(table.dataset.scBound)return;
              table.dataset.scBound='1';
              function clear(){table.querySelectorAll('.sc-hl,.sc-hl-cell').forEach(function(c){c.classList.remove('sc-hl','sc-hl-cell');});}
              table.addEventListener('mouseover',function(e){
                var cell=e.target.closest('td,th');if(!cell||!table.contains(cell))return;
                clear();
                var idx=cell.cellIndex,ri=cell.parentNode.rowIndex,rows=table.rows;
                for(var c=0;c<rows[ri].cells.length;c++)rows[ri].cells[c].classList.add('sc-hl');
                for(var r=0;r<rows.length;r++){if(rows[r].cells[idx])rows[r].cells[idx].classList.add('sc-hl');}
                cell.classList.remove('sc-hl');cell.classList.add('sc-hl-cell');
              });
              table.addEventListener('mouseleave',clear);
            });
            }
            scInit();
            if(!window.__scHook){
              window.__scHook=1;
              document.addEventListener('shopify:section:load',function(){
                document.querySelectorAll('body > [data-size-chart]').forEach(function(m){m.parentNode.removeChild(m);});
                scInit();
              });
            }
          })();
        
  if(!customElements.get('pd-roomy-video'))customElements.define('pd-roomy-video',class extends HTMLElement{
    connectedCallback(){
      if(this.video)return;this.video=this.querySelector('video');this.mobile=matchMedia('(max-width:700px)');this.reduced=matchMedia('(prefers-reduced-motion:reduce)');this.userPaused=false;
      this.play=()=>{if(this.visible&&this.mobile.matches&&!this.reduced.matches&&!this.userPaused&&!document.hidden)this.video.play().catch(()=>{});else this.video.pause();};
      this.toggle=()=>{this.userPaused=!this.video.paused;if(this.userPaused)this.video.pause();else this.video.play().catch(()=>{});};
      this.key=e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();this.toggle();}};
      this.state=()=>this.video.setAttribute('aria-label',this.video.paused?this.dataset.play:this.dataset.pause);
      this.video.muted=true;this.video.defaultMuted=true;this.video.autoplay=!this.reduced.matches;this.video.setAttribute('playsinline','');this.video.setAttribute('webkit-playsinline','');this.video.setAttribute('role','button');this.video.tabIndex=0;
      this.video.addEventListener('click',this.toggle);this.video.addEventListener('keydown',this.key);this.video.addEventListener('play',this.state);this.video.addEventListener('pause',this.state);this.video.addEventListener('canplay',this.play);document.addEventListener('visibilitychange',this.play);this.mobile.addEventListener('change',this.play);this.reduced.addEventListener('change',this.play);
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.play();},{threshold:.15});this.observer.observe(this.video);this.state();
    }
    disconnectedCallback(){this.video?.pause();this.observer?.disconnect();this.video?.removeEventListener('click',this.toggle);this.video?.removeEventListener('keydown',this.key);this.video?.removeEventListener('play',this.state);this.video?.removeEventListener('pause',this.state);this.video?.removeEventListener('canplay',this.play);document.removeEventListener('visibilitychange',this.play);this.mobile?.removeEventListener('change',this.play);this.reduced?.removeEventListener('change',this.play);this.video=null;}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-mobile-video-concepts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pd-mobile-concepts')) {
    customElements.define('pd-mobile-concepts', class extends HTMLElement {
      connectedCallback() {
        if (this.activePane) return;
        this.tabs = [...this.querySelectorAll('[role=tab]')];
        this.panes = [...this.querySelectorAll('[data-pane]')];
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.cleanups = [];
        this.panes.forEach(pane => {
          const video = pane.querySelector('video');
          const button = pane.querySelector('.pd-concepts__playback');
          const products = [...pane.querySelectorAll('[data-start]')];
          pane.video = video;
          pane.userPaused = false;
          button.hidden = false;
          const state = () => {
            button.toggleAttribute('data-playing', !video.paused);
            button.setAttribute('aria-label', video.paused ? button.dataset.play : button.dataset.pause);
          };
          const updateProduct = () => {
            const time = video.currentTime % 21;
            products.forEach(product => {product.hidden = !(time >= Number(product.dataset.start) && time < Number(product.dataset.end));});
          };
          const toggle = () => {
            this.loadVideo(video);
            if (video.paused) {pane.userPaused = false; video.play().catch(() => {});}
            else {pane.userPaused = true; video.pause();}
          };
          button.addEventListener('click', toggle);
          video.addEventListener('play', state);
          video.addEventListener('pause', state);
          video.addEventListener('timeupdate', updateProduct);
          this.cleanups.push(() => {button.removeEventListener('click', toggle);video.removeEventListener('play', state);video.removeEventListener('pause', state);video.removeEventListener('timeupdate', updateProduct);video.pause();});
        });
        this.onTab = event => {
          const tab = event.target.closest('[data-option]');
          if (tab) this.select(tab.dataset.option);
        };
        this.onKey = event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const option = event.key === 'Home' ? '1' : event.key === 'End' ? '2' : this.activePane.dataset.pane === '1' ? '2' : '1';
          this.select(option);
          this.tabs.find(tab => tab.dataset.option === option).focus();
        };
        this.onHash = () => this.select(location.hash === '#option2' ? '2' : '1', false);
        this.onVisibility = () => {
          this.panes.forEach(pane => {
            if (document.hidden || pane !== this.activePane || !pane.inView || this.reduced.matches) pane.video.pause();
            else if (!pane.userPaused) pane.video.play().catch(() => {});
          });
        };
        this.querySelector('[role=tablist]').addEventListener('click', this.onTab);
        this.querySelector('[role=tablist]').addEventListener('keydown', this.onKey);
        window.addEventListener('hashchange', this.onHash);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.reduced.addEventListener('change', this.onVisibility);
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const pane = entry.target.closest('[data-pane]');
            pane.inView = entry.isIntersecting;
            if (pane === this.activePane && pane.inView) {
              this.loadVideo(pane.video);
              if (!this.reduced.matches && !pane.userPaused && !document.hidden) pane.video.play().catch(() => {});
            } else pane.video.pause();
          });
        }, {threshold:0.15});
        this.panes.forEach(pane => this.observer.observe(pane.querySelector('.pd-concepts__film')));
        this.select(location.hash === '#option2' ? '2' : '1', false);
      }
      loadVideo(video) {
        if (video.dataset.loaded) return;
        video.querySelectorAll('source[data-src]').forEach(source => {source.src = source.dataset.src;});
        video.muted = true;
        video.load();
        video.dataset.loaded = 'true';
      }
      select(option, updateHash = true) {
        this.tabs.forEach(tab => {
          const selected = tab.dataset.option === option;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panes.forEach(pane => {
          pane.hidden = pane.dataset.pane !== option;
          if (!pane.hidden) this.activePane = pane;
          else pane.video.pause();
        });
        if (updateHash) history.replaceState(null, '', '#option' + option);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.cleanups?.forEach(cleanup => cleanup());
        this.querySelector('[role=tablist]')?.removeEventListener('click', this.onTab);
        this.querySelector('[role=tablist]')?.removeEventListener('keydown', this.onKey);
        window.removeEventListener('hashchange', this.onHash);
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.reduced?.removeEventListener('change', this.onVisibility);
        this.activePane = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-product-fit-concepts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pd-pdp-fit-concept')) customElements.define('pd-pdp-fit-concept',class extends HTMLElement {
    connectedCallback(){
      if(this.video)return;
      this.video=this.querySelector('video');this.views=[...this.querySelectorAll('[data-view-start]')];this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.timers=[];this.userPaused=false;
      this.video.muted=true;this.video.defaultMuted=true;this.video.autoplay=!this.reduced.matches;
      this.video.setAttribute('muted','');this.video.setAttribute('playsinline','');this.video.setAttribute('webkit-playsinline','');
      this.load=()=>{if(this.loaded)return;this.querySelectorAll('source[data-src]').forEach(s=>{s.src=s.dataset.src;});this.video.load();this.loaded=true;};
      this.play=()=>{if(this.inView&&!this.userPaused&&!this.reduced.matches&&!document.hidden)this.video.play().catch(()=>{});};
      this.retry=()=>{this.timers.forEach(clearTimeout);this.play();this.timers=[250,1000,2500].map(t=>setTimeout(this.play,t));};
      this.toggle=()=>{this.load();this.userPaused=!this.video.paused;if(this.userPaused)this.video.pause();else this.video.play().catch(()=>{});};
      this.key=e=>{if(e.key===' '||e.key==='Enter'){e.preventDefault();this.toggle();}};
      this.state=()=>this.video.setAttribute('aria-label',this.video.paused?this.dataset.play:this.dataset.pause);
      this.time=()=>this.views.forEach(v=>v.setAttribute('aria-pressed',this.video.currentTime>=Number(v.dataset.viewStart)&&this.video.currentTime<Number(v.dataset.viewEnd)?'true':'false'));
      this.seek=e=>{const button=e.target.closest('[data-view-start]');if(!button)return;this.load();const seek=()=>{this.video.currentTime=Number(button.dataset.viewStart)+.05;this.time();if(!this.reduced.matches){this.userPaused=false;this.video.play().catch(()=>{});}};if(this.video.readyState>0)seek();else this.video.addEventListener('loadedmetadata',seek,{once:true});};
      this.querySelector('.pd-pdp-fit-concept__views').addEventListener('click',this.seek);
      this.visibility=()=>{if(document.hidden)this.video.pause();else this.retry();};
      this.preference=()=>{this.video.autoplay=!this.reduced.matches;if(this.reduced.matches)this.video.pause();else this.retry();};
      this.gesture=e=>{if(e.target!==this.video&&this.inView){this.load();this.play();}};
      this.video.addEventListener('click',this.toggle);this.video.addEventListener('keydown',this.key);this.video.addEventListener('play',this.state);this.video.addEventListener('pause',this.state);this.video.addEventListener('timeupdate',this.time);this.video.addEventListener('canplay',this.retry);this.video.addEventListener('loadeddata',this.retry);
      document.addEventListener('visibilitychange',this.visibility);document.addEventListener('touchstart',this.gesture,{passive:true});window.addEventListener('pageshow',this.retry);window.addEventListener('focus',this.retry);this.reduced.addEventListener('change',this.preference);
      this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;if(this.inView){this.load();this.retry();}else this.video.pause();},{threshold:.01,rootMargin:'120px 0px'});this.observer.observe(this.video);this.time();
    }
    disconnectedCallback(){
      this.querySelector('.pd-pdp-fit-concept__views')?.removeEventListener('click',this.seek);this.observer?.disconnect();this.timers?.forEach(clearTimeout);this.video?.pause();
      this.video?.removeEventListener('click',this.toggle);this.video?.removeEventListener('keydown',this.key);this.video?.removeEventListener('play',this.state);this.video?.removeEventListener('pause',this.state);this.video?.removeEventListener('timeupdate',this.time);this.video?.removeEventListener('canplay',this.retry);this.video?.removeEventListener('loadeddata',this.retry);
      document.removeEventListener('visibilitychange',this.visibility);document.removeEventListener('touchstart',this.gesture);window.removeEventListener('pageshow',this.retry);window.removeEventListener('focus',this.retry);this.reduced?.removeEventListener('change',this.preference);this.video=null;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-product-fit-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pd-product-motion')) customElements.define('pd-product-motion',class extends HTMLElement {
    connectedCallback(){
      if(this.video)return;
      this.video=this.querySelector('video');this.views=[...this.querySelectorAll('[data-view-start]')];this.timers=[];this.userPaused=false;
      this.video.muted=true;this.video.defaultMuted=true;
      this.video.setAttribute('muted','');this.video.setAttribute('playsinline','');this.video.setAttribute('webkit-playsinline','');
      this.play=()=>{if(this.video.autoplay&&this.inView&&!this.userPaused&&!document.hidden)this.video.play().catch(()=>{});};
      this.retry=()=>{this.timers.forEach(clearTimeout);this.play();this.timers=[250,1000,2500].map(t=>setTimeout(this.play,t));};
      this.toggle=()=>{this.userPaused=!this.video.paused;if(this.userPaused)this.video.pause();else this.video.play().catch(()=>{});};
      this.key=e=>{if(e.key===' '||e.key==='Enter'){e.preventDefault();this.toggle();}};
      this.state=()=>this.video.setAttribute('aria-label',this.video.paused?this.dataset.play:this.dataset.pause);
      this.time=()=>this.views.forEach(v=>v.toggleAttribute('data-active',this.video.currentTime>=Number(v.dataset.viewStart)&&this.video.currentTime<Number(v.dataset.viewEnd)));
      this.visibility=()=>{if(document.hidden)this.video.pause();else this.retry();};
      this.gesture=e=>{if(e.target!==this.video)this.play();};
      this.video.addEventListener('click',this.toggle);this.video.addEventListener('keydown',this.key);this.video.addEventListener('play',this.state);this.video.addEventListener('pause',this.state);this.video.addEventListener('timeupdate',this.time);this.video.addEventListener('canplay',this.retry);this.video.addEventListener('loadeddata',this.retry);
      document.addEventListener('visibilitychange',this.visibility);document.addEventListener('touchend',this.gesture,{passive:true});document.addEventListener('click',this.gesture);window.addEventListener('pageshow',this.retry);window.addEventListener('focus',this.retry);
      this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;if(this.inView)this.retry();else this.video.pause();},{threshold:.01,rootMargin:'0px'});this.observer.observe(this.video);this.time();
    }
    disconnectedCallback(){
      this.observer?.disconnect();this.timers?.forEach(clearTimeout);this.video?.pause();
      this.video?.removeEventListener('click',this.toggle);this.video?.removeEventListener('keydown',this.key);this.video?.removeEventListener('play',this.state);this.video?.removeEventListener('pause',this.state);this.video?.removeEventListener('timeupdate',this.time);this.video?.removeEventListener('canplay',this.retry);this.video?.removeEventListener('loadeddata',this.retry);
      document.removeEventListener('visibilitychange',this.visibility);document.removeEventListener('touchend',this.gesture);document.removeEventListener('click',this.gesture);window.removeEventListener('pageshow',this.retry);window.removeEventListener('focus',this.retry);this.video=null;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-product-review-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pd-product-review-nav')) customElements.define('pd-product-review-nav',class extends HTMLElement {
    connectedCallback(){
      this.buttons=[...this.querySelectorAll('button')];
      this.panels=[...this.closest('main').querySelectorAll('pd-pdp-fit-concept')].map(el=>el.closest('.shopify-section'));
      this.panels.forEach((panel,i)=>{panel.classList.add('pd-product-review-panel');panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby','pd-product-tab-'+(i+1));this.buttons[i].id='pd-product-tab-'+(i+1);this.buttons[i].setAttribute('aria-controls',panel.id);});
      this.select=(index,write=true)=>{this.buttons.forEach((button,i)=>{button.setAttribute('aria-selected',i===index?'true':'false');button.tabIndex=i===index?0:-1;this.panels[i].hidden=i!==index;});if(write)history.replaceState(null,'','#fitoption'+(index+1));};
      this.onClick=event=>{const button=event.target.closest('[data-option]');if(button)this.select(Number(button.dataset.option)-1);};
      this.onKey=event=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();let i=this.buttons.indexOf(document.activeElement);if(event.key==='Home')i=0;else if(event.key==='End')i=2;else i=(i+(event.key==='ArrowRight'?1:2))%3;this.select(i);this.buttons[i].focus();};
      this.addEventListener('click',this.onClick);this.addEventListener('keydown',this.onKey);
      const index=Number(location.hash.replace('#fitoption',''))-1;this.select(index>=0&&index<3?index:0,false);if(index>=0&&index<3)requestAnimationFrame(()=>this.scrollIntoView({block:'start'}));
    }
    disconnectedCallback(){this.removeEventListener('click',this.onClick);this.removeEventListener('keydown',this.onKey);}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-product-square-preview"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pd-product-square')) customElements.define('pd-product-square',class extends HTMLElement {
    connectedCallback(){
      if(this.video)return;
      this.video=this.querySelector('video');this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.timers=[];this.userPaused=false;
      this.video.muted=true;this.video.defaultMuted=true;this.video.autoplay=!this.reduced.matches;
      this.video.setAttribute('muted','');this.video.setAttribute('playsinline','');this.video.setAttribute('webkit-playsinline','');
      this.load=()=>{if(this.loaded)return;this.querySelectorAll('source[data-src]').forEach(s=>{s.src=s.dataset.src;});this.video.load();this.loaded=true;};
      this.play=()=>{if(this.inView&&!this.userPaused&&!this.reduced.matches&&!document.hidden)this.video.play().catch(()=>{});};
      this.retry=()=>{this.timers.forEach(clearTimeout);this.play();this.timers=[250,1000,2500].map(t=>setTimeout(this.play,t));};
      this.toggle=()=>{this.load();this.userPaused=!this.video.paused;if(this.userPaused)this.video.pause();else this.video.play().catch(()=>{});};
      this.key=e=>{if(e.key===' '||e.key==='Enter'){e.preventDefault();this.toggle();}};
      this.state=()=>this.video.setAttribute('aria-label',this.video.paused?this.dataset.play:this.dataset.pause);
      this.visibility=()=>{if(document.hidden)this.video.pause();else this.retry();};
      this.preference=()=>{this.video.autoplay=!this.reduced.matches;if(this.reduced.matches)this.video.pause();else this.retry();};
      this.gesture=e=>{if(e.target!==this.video&&this.inView){this.load();this.play();}};
      this.video.addEventListener('click',this.toggle);this.video.addEventListener('keydown',this.key);this.video.addEventListener('play',this.state);this.video.addEventListener('pause',this.state);this.video.addEventListener('canplay',this.retry);this.video.addEventListener('loadeddata',this.retry);
      document.addEventListener('visibilitychange',this.visibility);document.addEventListener('touchstart',this.gesture,{passive:true});window.addEventListener('pageshow',this.retry);window.addEventListener('focus',this.retry);this.reduced.addEventListener('change',this.preference);
      this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;if(this.inView){this.load();this.retry();}else this.video.pause();},{threshold:.01,rootMargin:'120px 0px'});this.observer.observe(this.video);
    }
    disconnectedCallback(){
      this.observer?.disconnect();this.timers?.forEach(clearTimeout);this.video?.pause();
      this.video?.removeEventListener('click',this.toggle);this.video?.removeEventListener('keydown',this.key);this.video?.removeEventListener('play',this.state);this.video?.removeEventListener('pause',this.state);this.video?.removeEventListener('canplay',this.retry);this.video?.removeEventListener('loadeddata',this.retry);
      document.removeEventListener('visibilitychange',this.visibility);document.removeEventListener('touchstart',this.gesture);window.removeEventListener('pageshow',this.retry);window.removeEventListener('focus',this.retry);this.reduced?.removeEventListener('change',this.preference);this.video=null;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
